export default __webpack_public_path__ + "assets/close.007b2a07.svg";